import { render, staticRenderFns } from "./ButtonProduct.vue?vue&type=template&id=3882233c&"
import script from "./ButtonProduct.vue?vue&type=script&lang=ts&"
export * from "./ButtonProduct.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonProduct.vue?vue&type=style&index=0&id=3882233c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports